<div style="padding: 20px;">
    <div class="sheet-header">
        <h4>Procesando archivo: <strong>{{ fileName }}</strong></h4>

        <button mat-icon-button (click)="closeSheet()" aria-label="Cerrar panel">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-accordion class="example-headers-align" multi>
        <mat-expansion-panel *ngFor="let d of currentState.data; let i = index">
            <mat-expansion-panel-header>
                <mat-panel-title class="product-title">

                    <span class="product-index">{{ i + 1 }}.</span>

                    {{ d.data?.name ?? d.error?.originalData.label }}
                </mat-panel-title>

                <mat-panel-description class="status-description">
                    {{ d.error?.message?.endsWith('already exists.') ? 'Existe!!!' : d.error?.message }}
                </mat-panel-description>

                <div class="status-icon" [ngSwitch]="d.status">
                    <mat-icon *ngSwitchCase="'SUCCESS'" class="status-exito">check_circle</mat-icon>
                    <mat-icon *ngSwitchCase="'WARNING'" class="status-advertencia">warning</mat-icon>
                    <mat-icon *ngSwitchCase="'FAILURE'" class="status-fallo">error</mat-icon>
                </div>

            </mat-expansion-panel-header>
        </mat-expansion-panel>
    </mat-accordion>
</div>